import React from 'react';
import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  Card,
  CardBody,
  Stat,
  StatLabel,
  StatNumber,
  VStack,
  HStack,
  Button,
  Icon,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import {
  FiAirplay,
  FiBriefcase,
  FiCoffee,
  FiMapPin,
  FiShoppingBag,
  FiCompass,
  FiPackage,
  FiGrid,
} from 'react-icons/fi';

const bundlingDomainLinks = [
  { label: 'Airports', path: '/admin/airports/bundling-product', icon: FiAirplay },
  { label: 'Aviation Services', path: '/admin/aviation-services/bundling-product', icon: FiBriefcase },
  { label: 'Hospitality', path: '/admin/hospitality/bundling-product', icon: FiCoffee },
  { label: 'Destination Management', path: '/admin/destination-management/bundling-product', icon: FiMapPin },
  { label: 'Retail', path: '/admin/retail/bundling-product', icon: FiShoppingBag },
  { label: 'Tourism Development', path: '/admin/tourism-development/bundling-product', icon: FiCompass },
];

const ProductDashboard = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading size="lg" color="gray.700">
            Product Dashboard
          </Heading>
          <Text color="gray.600" mt={2}>
            Ringkasan bundling/product workspace dan shortcut untuk operasional per domain.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
          <Card bg="white" borderRadius="16px" boxShadow="sm">
            <CardBody>
              <Stat>
                <StatLabel color="gray.600">Domain Bundling</StatLabel>
                <StatNumber color="gray.800">6</StatNumber>
              </Stat>
            </CardBody>
          </Card>
          <Card bg="white" borderRadius="16px" boxShadow="sm">
            <CardBody>
              <Stat>
                <StatLabel color="gray.600">Package Manager</StatLabel>
                <StatNumber color="gray.800">Aktif</StatNumber>
              </Stat>
            </CardBody>
          </Card>
          <Card bg="white" borderRadius="16px" boxShadow="sm">
            <CardBody>
              <Stat>
                <StatLabel color="gray.600">Navigation Mode</StatLabel>
                <StatNumber color="gray.800">Dashboard</StatNumber>
              </Stat>
            </CardBody>
          </Card>
        </SimpleGrid>

        <Card bg="white" borderRadius="16px" boxShadow="sm">
          <CardBody>
            <Heading size="sm" color="gray.700" mb={4}>
              Shortcut Product & Bundling
            </Heading>
            <HStack spacing={3} mb={4} flexWrap="wrap">
              <Button
                colorScheme="blue"
                leftIcon={<Icon as={FiPackage} />}
                onClick={() => navigate('/admin/package-manager/my-packages')}
              >
                My Packages
              </Button>
              <Button
                variant="outline"
                leftIcon={<Icon as={FiGrid} />}
                onClick={() => navigate('/admin/package-manager/product-catalog')}
              >
                Product Catalog
              </Button>
            </HStack>
            <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={3}>
              {bundlingDomainLinks.map((feature) => (
                <Button
                  key={feature.path}
                  variant="outline"
                  justifyContent="flex-start"
                  leftIcon={<Icon as={feature.icon} />}
                  onClick={() => navigate(feature.path)}
                  h="44px"
                >
                  {feature.label}
                </Button>
              ))}
            </SimpleGrid>
          </CardBody>
        </Card>
      </VStack>
    </Box>
  );
};

export default ProductDashboard;
